import { config } from 'config';
import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect';
import i18n from 'i18nextInstance';
const { redirectAfterLogin, version } = config;

export const userIsAuthenticated = connectedRouterRedirect({
    authenticatedSelector: store => store.account.token !== null,
    redirectPath: i18n.t('/login'),
    wrapperDisplayName: 'UserIsAuthenticated'
});

export const userIsNotAuthenticated = connectedRouterRedirect({
    allowRedirectBack: false,
    authenticatedSelector: store => store.account.token === null,
    redirectPath: (state, ownProps) => {
        const { location: { search } } = ownProps;
        const urlParams = new URLSearchParams(search);
        const redirect = urlParams.get('redirect');
        return redirect ? decodeURI(redirect) : redirectAfterLogin ?? i18n.t('/dashboard');
    },
    wrapperDisplayName: 'UserIsNotAuthenticated'
});

export const versionChecked = connectedRouterRedirect({
    authenticatedSelector: ({
        account: {
            version: checkedVersion
        }
    }) => !checkedVersion || parseInt(checkedVersion, 10) === parseInt(version, 10),
    redirectPath: () => i18n.t('/nueva-version'),
    refresh: true,
    wrapperDisplayName: 'VersionChecked'
});
